const uuidv4 = () => ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
	(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
);

export default class User {
	constructor(data) {
		if (!data) {
			this.isEmpty = true;
			this.id = uuidv4();
		} else {
			const {id, position, answers, questions} = data;
			this.id = id || uuidv4();
			this.position = position || 0;
			this.answers = answers || [];
			this.questions = questions || [];
			this.isEmpty = false;
		}
	}
	get score() {
		return (this.answers || []).filter(a => a.is_correct).length;
	}
	get hasAnswers() {
		return this.answers && !!this.answers.length;
	}

	get hasQuestions() {
		return this.questions && !!this.questions.length;
	}
	static load(type) {
		const data = localStorage.getItem(`user-${type}`);
		if (!data) {
			return new User;
		}
		return new User(JSON.parse(data));
	}
	save(type) {
		localStorage.setItem(`user-${type}`, JSON.stringify({
			"id": this.id,
			"position": this.position,
			"answers": this.answers,
			"questions": this.questions,
		}));
	}
	reset(type, full = false) {
		localStorage.removeItem(`user-${type}`);
		if (full) {
			this.id = uuidv4();
			this.position = 0;
			this.answers = [];
			this.questions = [];
			this.isEmpty = true;
		}
	}
	setPosition(type, position) {
		this.position = position;
		this.save(type);
	}
	setQuestions(type, questions) {
		this.questions = questions;
		this.save(type);
	}
	addAnswer(type, answer) {
		this.answers.push(answer);
		this.save(type);
	}
	getValue(key) {
		return this[key];
	}
}
